// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// BRIDGE FILE - ADAPTER FÜR BACKWARD COMPATIBILITY
// +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

// 1. ALLE IMPORTE (Zwingend am Dateianfang für ESLint)
import useAppStore from './index';
import { 
    EmployeeData, 
    MonatsDaten, 
    MitarbeiterStatus, 
    MitarbeiterLeistungData, 
    ULMonatsDaten, 
    UnternehmerData, 
    PrognoseZeile, 
    BwaData, 
    LohnfaktorData, 
    GlobalSettings, 
    CountryData, 
    SettingsState, 
    ExtensionsKalkulatorExtension, 
    ExtensionsKalkulatorInputs, 
    ExtensionsKalkulatorState, 
    ClientDataState, 
    TeamMember, 
    AppSettings, 
    Snapshot, 
    StoredState 
} from './types';

// 2. SELEKTOREN: Weiterleitung
export { 
    useCalculationsSelector, 
    defaultCalculations, 
    calculateAllMetrics 
} from './selectors/calculations';

// 3. TYP RE-EXPORTE: Bereitstellung für die restliche App
export type { 
    EmployeeData, 
    MonatsDaten, 
    MitarbeiterStatus, 
    MitarbeiterLeistungData, 
    ULMonatsDaten, 
    UnternehmerData, 
    PrognoseZeile, 
    BwaData, 
    LohnfaktorData, 
    GlobalSettings, 
    CountryData, 
    SettingsState, 
    ExtensionsKalkulatorExtension, 
    ExtensionsKalkulatorInputs, 
    ExtensionsKalkulatorState, 
    ClientDataState, 
    TeamMember, 
    AppSettings, 
    Snapshot, 
    StoredState 
};

// 4. ZUSÄTZLICHE INTERFACES (Bridge-Spezifisch)
export interface GesamtleistungMonatData { monat: string; bedienumsatzBrutto: number; vkUmsatzBrutto: number; aussergewoehnlich: number; kostenErhoeht: boolean; abgeschlossen: boolean; frozenCalculations: any | null; }
export interface GesamtleistungSettings { planStundenTag: number; }
export interface UrlaubsverlustData { monat: string; urlaub: number; krankheit: number; }
export interface ULBasisdaten { simulationsStundenTag: number; }

// 5. DEFAULT EXPORT: Der eigentliche App-Store
export default useAppStore;